import {LANGUAGES} from '@/data/locales/index.js';

export const isUserLogged = () => {
  return !!localStorage.getItem('FYGR_ACCESS_TOKEN');
};

export const getLocaleFromIso = (localeIso) => {
  return localeIso.substring(0, 2);
};

export const getLocaleWithWeglot = async () => {
  await waitForWeglot();
  const bestAvailableLanguage = window.Weglot?.getBestAvailableLanguage();
  if (bestAvailableLanguage) {
    return LANGUAGES[window.Weglot.getBestAvailableLanguage().toUpperCase()]
      ? LANGUAGES[window.Weglot.getBestAvailableLanguage().toUpperCase()].iso
      : 'fr-FR';
  }
  return 'fr-FR';
};

export const waitForWeglot = async (maxAttempts = 20, interval = 400) => {
  return new Promise((resolve, reject) => {
    let count = 0;

    function checkWeglot() {
      count++;
      if (window.Weglot?.initialized) {
        resolve(window.Weglot);
      } else if (count >= maxAttempts) {
        reject(new Error('Maximum attempts reached: Weglot not available'));
      } else {
        setTimeout(checkWeglot, interval);
      }
    }

    checkWeglot();
  });
};
